import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { CustomerInfoCardConfiguration } from 'modules/customers/types';

interface Props {
  cardConfig: CustomerInfoCardConfiguration;
}

export const CustomerInfoCard = ({ cardConfig }: Props) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <Stack direction="row" spacing={1} justifyContent="space-between">
        <Typography variant="body2">{cardConfig.title}</Typography>
        <Box className={classes.icon}>{cardConfig.icon}</Box>
      </Stack>
      <Stack direction="row" spacing={1}>
        {cardConfig.content}
      </Stack>
    </Paper>
  );
};

const useStyles = makeStyles({
  root: {
    padding: '12px 16px',
    height: '100%',
  },
  icon: {
    display: 'flex',
    padding: '5px',
    backgroundColor: '#E3F2FD',
    border: '1px solid #BBDEFB',
    borderRadius: '4px',
  },
});
